<mat-form-field class="standard-select-form-field">
  <mat-select
    [(ngModel)]="selectedValue"
    class="custom-dropdown-select"
    name="custom-dropdown"
    [placeholder]="placeHolder"
    panelClass="standard-select-panel-class"
    (selectionChange)="selectedChanged()"
    disableOptionCentering="true"
  >
    @for (option of dropdownOptions; track option) {
    <mat-option
      [ngClass]="{ 'disabled-cursor': isDisabled(option), 'variety-option': isVarietyDropdown }"
      [value]="option"
      [disabled]="isDisabled(option)"
    >
      <div class="custom-dropdown-option">
        <span
          [ngClass]="{
            disabled: isDisabled(option),
            'variety-option-text':
              isVarietyDropdown &&
              option != 'No Scenario Selected' &&
              option != 'None Selected' &&
              option != 'Create a New Scenario'
          }"
          [matTooltip]="getTooltipText(option)"
          >{{ option }}</span
        >
        @if ( isVarietyDropdown && option != 'No Scenario Selected' && option != 'None Selected' &&
        option != 'Create a New Scenario' ) {
        <span class="sif sif-edit" matTooltip="Edit" (click)="editClicked(option)"></span>
        }
      </div>
    </mat-option>
    }
  </mat-select>
</mat-form-field>
